import { render } from "./indexList.vue?vue&type=template&id=554cdeb5&scoped=true"
import script from "./indexList.vue?vue&type=script&lang=js"
export * from "./indexList.vue?vue&type=script&lang=js"

import "./indexList.vue?vue&type=style&index=0&id=554cdeb5&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554cdeb5"]])

export default __exports__